<template>
    <div>
    <div class="py-3"></div>
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="`light-blue darken-3`"
        dark
    >    
    <v-toolbar-title>이미지 퀴즈 참여통계</v-toolbar-title>
    <v-spacer></v-spacer>
    </v-toolbar>
    
    <v-list>   
        <v-progress-linear
            v-if="loadingData"
            indeterminate
            color="blue"
        ></v-progress-linear>
       
        <v-list-item>
            <span><v-card-title style="font-weight:bold">
                잦은 불러오기는 서비스 서버 성능에 영향을 미칩니다.                
            </v-card-title></span>     
        </v-list-item>
        <v-list-item>
        <span style="width:140px"><v-card-title style="font-weight:bold">날짜 선택</v-card-title></span>        
        <!-- ====================== 시작 날짜를 지정합니다 ====================== -->
        <!-- <v-col cols="12" lg="6"> -->
        <span style="width:120px">
        <v-menu
            v-model="date_picker_1"
            :close-on-content-click="false"
            max-width="290"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="computedDateFormattedMomentjs_begin"
                clearable
                label="시작날짜"
                readonly
                v-bind="attrs"
                v-on="on"
                hide-details
                @click:clear="start_date = null"
            ></v-text-field>
        </template>
        <v-date-picker
            v-model="start_date"
            @change="date_picker_1 = false"
        ></v-date-picker>
        </v-menu>
        </span>
    
    <!-- </v-col> -->
    <span style="width:60px"/>
    ~
    <!-- ====================== SPACE ====================== -->
    <span style="width:60px"/>
    <!-- ====================== 시작 날짜를 지정합니다 ====================== -->
        <!-- <v-col cols="12" lg="6"> -->
            
    <span style="width:120px">
        <v-menu
            v-model="date_picker_2"
            :close-on-content-click="false"
            max-width="290"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="computedDateFormattedMomentjs_end"
                clearable
                label="종료날짜"
                readonly
                v-bind="attrs"
                v-on="on"
                hide-details
                @click:clear="end_date = null"
            ></v-text-field>
        </template>
        <v-date-picker
            v-model="end_date"
            @change="date_picker_2 = false"
        ></v-date-picker>
        </v-menu>
        </span>
        <v-spacer></v-spacer>
        <!-- 
        <v-btn width="120px"  color="blue-grey lighten-3"  @click="OnSearch_Event_Today">오늘</v-btn>
        -->   
        <v-spacer></v-spacer>            
        <v-btn width="120px"  color="lime accent-3"  @click="OnSearch_Data" style="font-weight: 900;">불러오기</v-btn>
        </v-list-item>
        <v-list-item v-if="is_enable_download" class="d-flex justify-center">
            <v-btn width ="360px" color="yellow" @click="downloadExcel" style="font-weight: 900;">  
            ({{start_date +'~'+ end_date}})    다운받기
            </v-btn>
        </v-list-item>

    </v-list>
    </v-card>

    <div class="py-3"></div>
    
    <!-- <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="`light-blue darken-3`"
        dark
    >    
    <v-toolbar-title>패키지 선택</v-toolbar-title>
    <v-spacer></v-spacer>
    </v-toolbar>
        <div class="pa-3">
            <v-row>
                <v-col>
                    <v-select
                        v-model="selcetedPackage"
                        :items="filterdPackage"
                        label="프로젝트그룹 선택"
                        item-text="package"
                        item-value="package"
                        filled
                        outlined
                        dense
                        hide-details
                    ></v-select>
                </v-col>
                <v-col>
                </v-col>
            </v-row>

        </div>
    </v-card>

    <div class="py-3"></div>



    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'grey darken-1'"
        dark
    >    
    <v-toolbar-title>검색 결과</v-toolbar-title>
    <v-spacer/>
    <v-btn
        color='#37474F'
        @click="DownloadData_Csv">
        다운로드
        <v-icon>mdi-download</v-icon>
    </v-btn>
    </v-toolbar>
    <v-list>
        <v-data-table         
        :footer-props="{'items-per-page-options':[50, -1]}"
        :headers="headers" 
        :items="filterdData"
        :loading="loadingData"
        >        
        <template v-slot:item="row">            
            <tr>
            <td>{{row.item.event_tag}}</td>
            <td>{{row.item.event_name}}</td>
            <td>{{row.item.count}}</td>
            <td>{{row.item.package}}</td>
            </tr>
        </template>
        </v-data-table>
    </v-list>
    </v-card> -->
    </div>   
    
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
import { format, parseISO } from 'date-fns'
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
    name: 'UserList',

    data: () => ({
        selcetedPackage:'',

        targetUser:'USER_ID',
        isMailAll:false,
        loadingData:false,        
        start_date: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        end_date:format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        date_picker_1: false,
        date_picker_2: false,

        downloaded_data:[],
 
        selected_itemList:[],   ///인덱스만 담기것지 나중에 전송할때는 한번 가공하도록 한다         
        selected_itemList_count:[],   
        title_type_items:[],    //타이틀 설정 하도록 
        event_history_all:[
            {  
                event_key: 'djsfeosk',
                event_title: '네이버 사전예약 이벤트',
                count:555,
                package:'com.newday7.pantsceo',
            },
        ]
    }),

    created()
    {
        this.start_date = moment().subtract(1,'day').format('yyyy-MM-DD');
        this.end_date = moment().subtract(0,'day').format('yyyy-MM-DD');
        //this.OnSearch_Event();
    },

    methods:{
        ...mapActions([
            //'GET_LOG_TODAY',
            'GET_IMG_QUIZ_REPORT'
        ]),
        OnClickUserInfo(_item)
        {
            this.loadingData = true;
            alert(_item.user_id + "의 정보를 확인합니다.");
            //let locateValue  = location.protocol +  "//"+location.host+'/story_eventedit?seq_event_new='+selectItem.seq_event_new;
            //window.location.href = locateValue;
        },
        OnClickUser_Mail(_item)
        {
            this.loadingData = false;
            alert(_item.user_id + "에게 메일을 보내려고합니다.");
        },
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },
        OnSearch_Data()
        {
            //console.log(log_type);
            //start_date, end_date
            this.loadingData = true;
            let start_date = this.start_date;
            let end_date = this.end_date;
            this.GET_IMG_QUIZ_REPORT({ start_date, end_date}).then((body_data)=>{
                this.downloaded_data = body_data.result;
                // = body_data.result;
                this.loadingData = false;
     
            });
        },
        //중간광고 , 5초형 광고 
        downloadExcel() {
            // JSON 데이터를 워크시트로 변환
            let tempData_1 = [];
            let tempData_2 = [];
            //
            for (let i = 0; i < this.downloaded_data.length; i++) {
                    let item = this.downloaded_data[i];
                 
                    let newItem1 = {
                        '퀴즈': item.etc_info,
                        '참여수': item.cnt_join,
                        '광고 보고 클리어': item.cnt_clear_ad,
                        '광고 안보고 클리어': item.cnt_clear_clean,
                        '이탈': item.cnt_join - (item.cnt_clear_clean +  item.cnt_clear_ad),
                        '힌트': item.cnt_hint,
                        '지우개': item.cnt_eraser,
                        '슈퍼패스': item.cnt_pass,
                        '더보기1': item.cnt_more_1,
                        '더보기2': item.cnt_more_2,
                        '더보기3': item.cnt_more_3,
                        '광고횟수 총합': item.cnt_ad_view,
                        '5초광고': item.cnt_ad_type_1,
                        '전면광고': item.cnt_ad_type_2,
                    };
                    console.log(`${item.cnt_join} / ${item.cnt_clear_ad} / ${item.cnt_clear_clean}`); 
                    //console.log('item:', JSON.stringify(item));
                    let cnt_join = item.cnt_join <= 0?1:item.cnt_join;
                    
                    let ad5SecRate = (item.cnt_ad_type_1 == 0 || item.cnt_ad_view == 0) ? 0 : (item.cnt_ad_type_1 / item.cnt_ad_view * 100);
                    let adFullRate = (item.cnt_ad_type_2 == 0 || item.cnt_ad_view == 0) ? 0 : (item.cnt_ad_type_2 / item.cnt_ad_view * 100);

                    let newItem2 = {
                        '퀴즈': item.etc_info,
                        '참여수': item.cnt_join,
                        '광고 보고 클리어(%)': ((item.cnt_clear_ad / cnt_join) * 100) + '%',
                        '광고 안보고 클리어(%)': ((item.cnt_clear_clean / cnt_join) * 100) + '%',
                        '이탈(%)': ((item.cnt_join - (item.cnt_clear_clean +  item.cnt_clear_ad)) /  cnt_join * 100) + '%',
                        '힌트(%)': (item.cnt_hint / cnt_join * 100 ) + '%',
                        '지우개(%)': (item.cnt_eraser / cnt_join * 100 ) + '%',
                        '슈퍼패스(%)': (item.cnt_pass / cnt_join * 100 ) + '%',
                        '더보기1(%)': (item.cnt_more_1 / cnt_join * 100 ) + '%',
                        '더보기2(%)': (item.cnt_more_2 / cnt_join * 100 ) + '%',
                        '더보기3(%)': (item.cnt_more_3 / cnt_join * 100 ) + '%',
                        '광고횟수 총합 ': item.cnt_ad_view,
                        '5초광고 (%)': (ad5SecRate) + '%',
                        '전면광고 (%)': (adFullRate) + '%',
                    };

                    tempData_1.push(newItem1);
                    tempData_2.push(newItem2);
                }
            const worksheet1 = XLSX.utils.json_to_sheet(tempData_1);
            const worksheet2 = XLSX.utils.json_to_sheet(tempData_2);
            
            // 워크북 생성
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet1, "기본통계");
            XLSX.utils.book_append_sheet(workbook, worksheet2, "퍼센트 통계");


            // 엑셀 파일 생성 및 Blob으로 변환
            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
            const data = new Blob([excelBuffer], { type: "application/octet-stream" });

            // 파일 저장 (엑셀 다운로드)
            saveAs(data, `${this.start_date}_${this.end_date}.xlsx`);
        }
    },
    computed: {
        isLive(){
            return config.isLive;
        },
        computedDateFormattedMomentjs_begin () {
            return this.start_date ? moment(this.start_date).format('YYYY-MM-DD') : ''
        },
        computedDateFormattedMomentjs_end () {
            return this.end_date ? moment(this.end_date).format('YYYY-MM-DD') : ''
        },
        // 선택된 페키지에 따라서 필터링된 데이터를 넣어주는 로직이 필요하다.
        // 데이터가 event_history_all로 들어오면, 데이터를 페키지로 나누어주는 로직이 필요하다.
        filterdData () {
            return this.event_history_all.filter( item => item.package == this.selcetedPackage)
        },
        filterdPackage () {
            let packages = {}
            this.event_history_all.forEach((item) => {
                if(!packages[item.package]){
                    packages[item.package] = item.package
                }
            })
            packages = Object.values(packages)
            packages = packages.map( (item) => {
                return {"package": item}
            })
            return packages
        },
        totalCount () {
            return this.filterdData[0]?`(${this.filterdData.reduce((p, c, i, a) => {
                return p + parseInt(c.count)
            }, 0).toLocaleString()})`:''
        },
        headers () {
            return [            
            { text: '이벤트 키', value: 'event_key' },
            { text: '이벤트 타이틀', value: 'event_title' },
            { text: `카운트 ${this.totalCount}`, value: 'count' },
            { text: '패키지', value: 'package' },
        ]
        },
        is_enable_download()
        {
            return this.downloaded_data.length > 0 ? true : false;
        }
    },
    components:{
    },

};
</script>
